import './bootstrap'
import '../css/app.css'
import './icons'



import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m'

import ModalAlert from '@/Components/Custom/Alerts/Modal.vue'
import { modal } from 'momentum-modal'

import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import Popper from "vue3-popper"

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import store from '@/store'
import { vMaska } from 'maska'

import Layout from '@/Layouts/Authenticated.vue'

import './UnauthorizedAxios'

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        const page = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'))

        page.default.layout = page.default.layout || Layout
        return page
    },
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(modal, {
                resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'))
            })
            .use(ZiggyVue, Ziggy)
            .use(store)
            .use(VueVirtualScroller)
            .use(VCalendar, {})
            .directive('maska', vMaska)
            .component('Popper', Popper)
            .component('modal-alert', ModalAlert)
            .component('font-awesome-icon', FontAwesomeIcon)
            .mount(el)
    },
    progress: {
        color: '#00b7ff'
    }
})

document.addEventListener('DOMContentLoaded', function (e) {
    if (localStorage.theme === 'light' || !('theme' in localStorage)) {
        document.documentElement.classList.remove('dark')
        localStorage.setItem('theme', 'light')
    } else {
        document.documentElement.classList.add('dark')
    }
})
